import axios from 'axios';
import axiosInstance from 'src/utils/AxiosInstance';

const baseUrl = process.env.REACT_APP_PARTNERSHIP_API_URL;

export const getCurrentUser = async (access_token) => {
  const apiUrl = `${baseUrl}/users/me/`;
  const bearer = `Bearer ${access_token}`;
  try {
    const response = await axios.get(apiUrl, {
      headers: {
        Accept: 'application/json',
        Authorization: bearer,
      },
    });

    return response.data;
  } catch (error) {
    console.log('TEST', error);
    throw error;
  }
};

const UserService = {
  readUsersMe: async function () {
    const apiUrl = baseUrl + '/users/me';
    try {
      const response = await axiosInstance.get(apiUrl);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  getUserById: async function (id) {
    const apiUrl = baseUrl + '/users/' + id;
    try {
      const response = await axiosInstance.get(apiUrl);
      const partnerUrl = baseUrl + '/partners/' + response.data.partner_id;
      const partners = await axiosInstance.get(partnerUrl);
      const json = [];
      json['user'] = response.data;
      json['partner'] = partners.data;
      return json;
    } catch (error) {
      throw error;
    }
  },

  getUsers: async function (role) {
    if (role.toLowerCase() === "admin"){
        const apiUrl = baseUrl + '/users';
      try {
        const response = await axiosInstance.get(apiUrl);
        return response.data;
      } catch (error) {
        throw error;
      }
    }
  },
};

export default UserService;
